module.exports = __webpack_public_path__ + "img/checklist.75f94d47.png";